import { Row } from '@amzn/meridian';
import { MFormCheckbox } from 'components/MeridianFinalFormWrappers/MFormCheckbox';
import { MFormInput } from 'components/MeridianFinalFormWrappers/MFormInput/MFormInput';
import type { TpCampaignRequiredFormFlavorFragment } from 'generated/graphql';
import { useSpyOnFieldValue } from 'hooks/form-spy/useSpyOnFieldValue';
import { useGetFieldPath } from 'utils/pathing';

type FlavorNameEditorProps = {
  flavorIndex: number;
};

export const FlavorNameEditor = ({ flavorIndex }: FlavorNameEditorProps) => {
  const gp = useGetFieldPath<TpCampaignRequiredFormFlavorFragment>(`flavors.${flavorIndex}`);
  const hasGeneratedName = useSpyOnFieldValue<boolean>({
    fieldPath: gp('hasGeneratedName'),
  });

  return (
    <Row
      alignmentVertical="bottom"
      widths={[
        'fill',
        'fit',
      ]}
    >
      <MFormInput disabled={!!hasGeneratedName} label="Creative name" name={gp('creativeName')} />
      <MFormCheckbox id={`flavor-name-auto-gen-checkbox-${flavorIndex}`} label="Auto-generate name" name={gp('hasGeneratedName')} />
    </Row>
  );
};
